module.exports = __webpack_public_path__ + "img/product_banner_digital.2d77f29c.png";